import { _DEBUG } from './constants';

//-----------------------------------
// ### Set Same Height ###
//------------------------------------
export const setSameHeight = (parent, childSelector) => {
  let highestBox = 0;
  $(childSelector, parent).each((index, element) => {
    if ($(element).height() > highestBox) {
      highestBox = $(element).height();
    }
  });
  $(childSelector, parent).height(highestBox);
};

export const setCursor = (value) => {
  $('body').css('cursor', value);
};

export const keepalive = () => {
  if (_DEBUG) console.log('keepalive..........?');

  let basket_empty = window.dataLayer[0].basket.length == 0;
  let basket_add =
    window.dataLayer.filter(function (e) {
      return e.event === 'addToBasket';
    }).length > 0;

  if (!basket_empty || basket_add) {
    $.get('/rpc.php', { action: 'keepalive' }).done(function (data) {
      if (_DEBUG) console.log('keepalive....send');
    });
  } else {
    if (_DEBUG) console.log('keepalive....not needed!');
  }
};

export const toggleText = (element, collapsed = true) => {
  if (collapsed) {
    $(element).text($(element).data('collapsed'));
  } else {
    $(element).text($(element).data('collapse'));
  }
};

export const debounce = (func, delay) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
};

export const insertDotLoaderElement = (element) => {
  element.innerHTML = '';
  const loader = document.createElement('div');
  loader.classList.add('dot-loader');
  loader.innerHTML = `
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  `;
  element.appendChild(loader);
};

/**
 * Parses a price string and converts it to a float number.
 */
export const parsePrice = (text) => {
  return parseFloat(
    String(text)
      .replace(/\./g, '')
      .replace(',', '.')
      .replace(/[^\d.]/g, ''),
  );
};

/**
 * Returns the shop code from the body dataset or defaults to 'aponeo_de'.
 *
 * For importing css and js assets, use `themeAssetUrl(...)`
 *
 * @returns {string} aponeo_de|meine-onlineapo_de|pharmeo_at|pharmeo_de|sparmed_de
 */
export const getShopCode = () => {
  return document.body.dataset.shopcode || 'aponeo_de';
};
